import { render, staticRenderFns } from "./compareProgress.vue?vue&type=template&id=2bd4163d&scoped=true"
import script from "./compareProgress.vue?vue&type=script&lang=js"
export * from "./compareProgress.vue?vue&type=script&lang=js"
import style0 from "./compareProgress.vue?vue&type=style&index=0&id=2bd4163d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4163d",
  null
  
)

export default component.exports